import { gql } from '@apollo/client';

export const CREATE_COUNTRY_VAT_CONFIG = gql`
    mutation CreateCountryVatConfig($input: CreateCountryVatConfigInput!) {
        createCountryVatConfig(input: $input) {
            id
            countryCode
            countryName
            vatPercent
            createdAt
            updatedAt
        }
    }
`;

export const UPDATE_COUNTRY_VAT_CONFIG = gql`
    mutation UpdateCountryVatConfig(
        $id: ID!
        $input: UpdateCountryVatConfigInput!
    ) {
        updateCountryVatConfig(id: $id, input: $input) {
            id
            countryCode
            countryName
            vatPercent
            createdAt
            updatedAt
        }
    }
`;

export const DELETE_COUNTRY_VAT_CONFIG = gql`
    mutation DeleteCountryVatConfig($id: ID!) {
        deleteCountryVatConfig(id: $id)
    }
`;

export const CREATE_TAX_CODE_CONFIG = gql`
    mutation CreateTaxCodeConfig($input: CreateTaxCodeConfigInput!) {
        createTaxCodeConfig(input: $input) {
            id
            code
            description
            isZeroRated
            createdAt
            updatedAt
        }
    }
`;

export const UPDATE_TAX_CODE_CONFIG = gql`
    mutation UpdateTaxCodeConfig($id: ID!, $input: UpdateTaxCodeConfigInput!) {
        updateTaxCodeConfig(id: $id, input: $input) {
            id
            code
            description
            isZeroRated
            createdAt
            updatedAt
        }
    }
`;

export const DELETE_TAX_CODE_CONFIG = gql`
    mutation DeleteTaxCodeConfig($id: ID!) {
        deleteTaxCodeConfig(id: $id)
    }
`;
